import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Save, ArrowRight } from "lucide-react";

export default function SavePrompt({ toolKey, what }) {
  return (
    <div className="relative overflow-hidden border border-primary/40 bg-primary/10 rounded-sm p-6 md:p-8 no-print animate-in fade-in slide-in-from-bottom-2 duration-500" data-testid={`save-prompt-${toolKey}`}>
      <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-primary/20 blur-3xl" />
      <div className="relative flex flex-col md:flex-row md:items-center gap-5">
        <Save className="w-8 h-8 text-primary shrink-0" />
        <div className="flex-1">
          <div className="overline text-primary">Nice work — that took real effort</div>
          <div className="font-display font-bold text-xl md:text-2xl mt-1">Sign up free to save this report and track it over time.</div>
          <p className="text-sm text-muted-foreground mt-1">Keep every {what} in one place, trend scores audit over audit, and assign actions to your team.</p>
        </div>
        <Link to={`/register?source=tool-${toolKey}`}>
          <Button size="lg" className="rounded-sm h-12 bg-accent hover:bg-accent/90 text-white" data-testid={`save-prompt-signup-${toolKey}`}>
            Save my results <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </div>
    </div>
  );
}
